import { render } from "./Popup2.vue?vue&type=template&id=4b8d4dcc&scoped=true"
import script from "./Popup2.vue?vue&type=script&lang=js"
export * from "./Popup2.vue?vue&type=script&lang=js"

import "./Popup2.vue?vue&type=style&index=0&id=4b8d4dcc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8d4dcc"]])

export default __exports__